import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MenuComponent } from './menu/menu.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { AwardsComponent } from './awards/awards.component';
import { VDPickerComponent } from './vd-picker/vd-picker.component';
import { DateRangePickerComponent } from './daterangepicker/daterangepicker.component';
import { PortfolioDetailsComponent } from './portfolio-details/portfolio-details.component';
import { PortfolioTransactionsComponent } from './portfolio-details/portfolio-transactions.component';
import { PortfolioAssetsComponent } from './portfolio-details/portfolio-assets.component';
import { PincodeInputComponent } from './pincode-input/pincode-input.component';
import { NWMTableComponent } from './NWMTable/NWMTable.component';
import { NWMCharts } from 'app/components/NWMCharts/NWMCharts.module';
import { NWMTfaComponent } from './tfa/tfa.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { NewsComponent } from './News/news.component';

import { EqualValidator } from './equal-validator.directive';
import { ClickStopPropagationDirective } from './click-stop-propagation.directive';
import { CapsLockComponent } from './caps-lock/caps-lock.component';

import { SharedModule } from "app/modules/shared/shared.module"; // using minusSignToParens in PortfolioDetailsComponent

import { NgbModule } from "@ng-bootstrap/ng-bootstrap"; // being used only for pagination in NWMTable

@NgModule({
    imports: [
        RouterModule,
        FormsModule,
        NWMCharts,
        NgbModule,
        SharedModule.forRoot(),
        EqualValidator,
        ClickStopPropagationDirective,
        CapsLockComponent,
        MenuComponent,
        SubMenuComponent,
        SideMenuComponent,
        AwardsComponent,
        VDPickerComponent,
        DateRangePickerComponent,
        PortfolioDetailsComponent,
        PortfolioTransactionsComponent,
        PortfolioAssetsComponent,
        PincodeInputComponent,
        NWMTableComponent,
        NWMTfaComponent,
        DisclaimerComponent,
        NewsComponent
    ],
    providers: [],
    exports: [
        EqualValidator,
        ClickStopPropagationDirective,
        CapsLockComponent,
        MenuComponent,
        SubMenuComponent,
        SideMenuComponent,
        AwardsComponent,
        VDPickerComponent,
        DateRangePickerComponent,
        PortfolioDetailsComponent,
        PortfolioTransactionsComponent,
        PortfolioAssetsComponent,
        PincodeInputComponent,
        NWMTableComponent,
        NWMTfaComponent,
        DisclaimerComponent,
        NewsComponent
    ]
})
export class NWMControls { }
